import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, FormGroup, FormLabel, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { LoginService } from "../../services/LoginService";
import { Alert } from "../../shared/Alerts";
import roleJson from "../../util/role.json";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReCAPTCHA from "react-google-recaptcha";

const Login = () => {
    const navigate = useNavigate();
    const [reCaptchaToken, setReCaptchaToken] = useState('');
    const [currentHost, setcurrentHost] = useState(null)

    const handleRecaptcha = (value) => {
        setReCaptchaToken(value);
    }

    const submitLoginForm = (event) => {
        if (currentHost) {
            if (!reCaptchaToken) {
                Alert.error("ReCaptcha harus centang");
                btnPointer.innerHTML = 'Login';
                btnPointer.removeAttribute('disabled');
                return;
            }
        }

        event.preventDefault();
        const formElement = document.querySelector('#loginForm');
        const formData = new FormData(formElement);
        const formDataJSON = Object.fromEntries(formData);
        const postData = { "namaUser": formDataJSON.username, "kataSandi": formDataJSON.password };
        const btnPointer = document.querySelector('#login-btn');
        btnPointer.innerHTML = 'Please wait..';
        btnPointer.setAttribute('disabled', true);

        LoginService.signin(postData)
            .then((res) => {
                if (res.data.messages.message) {
                    Alert.error(res.data.messages.message)
                    return;
                }

                // let isRole = roleJson.role.filter(e => e == res.data.data.kelompokUser.kelompokUser).length > 0 ? true : false;
                // if (isRole) {
                    let dataUserLogin = {
                        id: res.data.data.id,
                        kdUser: res.data.data.namaUser,
                        waktuLogin: new Date()
                    };
                    window.localStorage.setItem('datauserlogin', JSON.stringify(dataUserLogin));
                    window.localStorage.setItem('pegawai', JSON.stringify(res.data.data.pegawai));
                    window.localStorage.setItem('sotk_coor', JSON.stringify(res.data.data.sotk_coor));
                    sessionStorage.setItem('statusCode', res.data.data.kelompokUser.kelompokUser);
                    sessionStorage.setItem('authorization', res.data.messages['X-AUTH-TOKEN']);
                    setTimeout(() => {
                        window.location.reload(true)
                    }, 1000);
                // } else {
                //     Alert.error("Anda tidak memiliki akses sistem")
                //     return;
                // }

            })
            .finally(() => {
                btnPointer.innerHTML = 'Login';
                btnPointer.removeAttribute('disabled');
            })
            .catch(error => {
                Alert.error(error.message)
            })
    }

    useEffect(() => {
        setcurrentHost(window.location.protocol == 'http:' ? false : true);
    }, [])

    return (
        <React.Fragment>
            <ToastContainer />
            <Container className="my-5">
                {/* <div className="justify-content-center"> */}
                <Row className="vh-50 align-items-center justify-content-center">
                    <Col className="col-sm-8 col-md-6 col-lg-4 p-4">
                        <h2 className="text-center fw-normal mb-3">SIGN IN</h2>
                        <Form id="loginForm" onSubmit={submitLoginForm}>
                            <FormGroup className="mb-3">
                                <FormLabel htmlFor={'login-username'}>Username</FormLabel>
                                <input type={'text'} className="form-control" id={'login-username'} name="username" required />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <FormLabel htmlFor={'login-password'}>Password</FormLabel>
                                <input type={'password'} className="form-control" id={'login-password'} name="password" required />
                            </FormGroup>
                            <ReCAPTCHA sitekey={process.env.REACT_APP_SITE_KEY} onChange={handleRecaptcha} />
                            <div className="d-grid gap-2">
                                <Button type="submit" className="btn-success mt-2" id="login-btn">Login</Button>
                            </div>
                            <div className="d-grid text-center mt-2">
                                <span className="f7">"Username dan Password Menggunakan Login <strong><mark>SMART</mark></strong>"</span>
                            </div>
                        </Form>
                    </Col>
                </Row>

                {/* </div> */}
            </Container>
        </React.Fragment>
    );
}

export default Login;
